import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SparkCoreModule } from '@core/core.module';
import { SparkCardModule } from '@shared/components/card/card.module';
import { SparkMetaContentModule } from '@shared/components/meta-content/meta-content.module';
import { SummaryFieldModule } from '@shared/components/summary-field/summary-field.module';
import { SharedModule } from '@shared/shared.module';

import { ApplicantListViewComponent } from './components/applicant-list-view/applicant-list-view.component';
import { AssetListViewComponent } from './components/asset-list-view/asset-list-view.component';
import { DependentListViewComponent } from './components/dependent-list-view/dependent-list-view.component';
import { IncomeListViewComponent } from './components/income-list-view/income-list-view.component';
import { LiabilityListViewComponent } from './components/liability-list-view/liability-list-view.component';
import { PurposeViewComponent } from './components/purpose-view/purpose-view.component';
import { KycReviewComponent } from './components/review/review.component';
import { SparkKycSummaryAcceptedComponent } from './components/summary/accepted/accepted.component';
import { SparkKycSummaryDefaultComponent } from './components/summary/default/default.component';
import { SparkKycSummaryExpiredComponent } from './components/summary/expired/expired.component';
import { SparkKycSummaryReviewComponent } from './components/summary/review/review.component';
import { SparkKycSummarySentComponent } from './components/summary/sent/sent.component';
import { SparkKycSummaryCreatedComponent } from './components/summary/created/created.component';
import { SparkKycSummaryComponent } from './components/summary/summary.component';
import { ApplicantNamePipe } from './pipes/applicant-name.pipe';
import { LivingExpenseFieldToLabelPipe } from './pipes/living-expense-field-to-label.pipe';
import { HasAnyPipe } from './pipes/has-any.pipe';
import { LocalAddressToStringPipe } from './pipes/local-address-to-string.pipe';
import { NativeArrayPipe } from './pipes/native-array.pipe';
import { ObjectToMapPipe } from './pipes/object-to-map.pipe';
import { UndefinedToNullPipe } from './pipes/undefined-to-null.pipe';

@NgModule({
  declarations: [
    ApplicantListViewComponent,
    AssetListViewComponent,
    IncomeListViewComponent,
    LiabilityListViewComponent,
    PurposeViewComponent,
    KycReviewComponent,
    ApplicantNamePipe,
    ObjectToMapPipe,
    LivingExpenseFieldToLabelPipe,
    LocalAddressToStringPipe,
    DependentListViewComponent,
    NativeArrayPipe,
    HasAnyPipe,
    SparkKycSummaryComponent,
    SparkKycSummarySentComponent,
    SparkKycSummaryCreatedComponent,
    SparkKycSummaryExpiredComponent,
    SparkKycSummaryDefaultComponent,
    SparkKycSummaryReviewComponent,
    SparkKycSummaryAcceptedComponent,
    UndefinedToNullPipe
  ],
  imports: [
    CommonModule,
    SharedModule,
    SummaryFieldModule,
    SparkCardModule,
    SparkCoreModule,
    SparkMetaContentModule
  ],
  exports: [KycReviewComponent, SparkKycSummaryComponent]
})
export class KycModule {}
